import { render, staticRenderFns } from "./Choices.vue?vue&type=template&id=93712cf0&scoped=true&"
import script from "./Choices.vue?vue&type=script&lang=ts&"
export * from "./Choices.vue?vue&type=script&lang=ts&"
import style0 from "./Choices.vue?vue&type=style&index=0&id=93712cf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93712cf0",
  null
  
)

export default component.exports